module.exports = __webpack_public_path__ + "static/img/no_art.1509b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_art.png
// module id = zu6a
// module chunks = 1